



























































import { Component, Prop, Vue } from 'vue-property-decorator'
import FormInput from '@/components/FormInput.vue'
import { FormularData, FormularErrors } from '@/model/form-data'
import Amount from '@/components/Amount.vue';

@Component({
  components: {
    Amount,
    FormInput
  }
})
export default class CustomForm extends Vue {
  @Prop() public formData!: FormularData;
  @Prop() public duration!: number;
  @Prop() public formularErrors!: FormularErrors;
  @Prop() public minDate!: string;
  @Prop() public intentions!: string;
}
